import React, { useState } from 'react';
import logopng from '../images/logopng.png';
import {
  AppBar, Toolbar, Typography, Button, IconButton, Grid, Menu, MenuItem, Drawer, List, ListItem, ListItemText, Divider, Paper, Popper, ListItemIcon
} from '@mui/material';
import { Facebook, Twitter, LinkedIn, Instagram, Menu as MenuIcon, ChevronRight, FlightTakeoff, School, Public } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useNavigate } from 'react-router-dom'; // Import useNavigate



const Navbar = () => {
  const [anchorElCourses, setAnchorElCourses] = useState(null);
  const [anchorElManagement, setAnchorElManagement] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [subAnchorEl, setSubAnchorEl] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [studyVisaAnchorEl, setStudyVisaAnchorEl] = useState(null);
  const [residentVisaAnchorEl, setResidentVisaAnchorEl] = useState(null);


  const navigate = useNavigate(); // Initialize useNavigate

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const countriesR = ["USA", "UK", "Australia", "Canada"];
  const countries = ["USA", "UK", "Australia", "Canada"];

  const handleOpenMenu = (event) => setAnchorEl(event.currentTarget);
  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSubAnchorEl(null);
    setAnchorElCourses(null);
    setAnchorElManagement(null);
  };

  const handleManagementClick = (event) => {
    setAnchorElManagement(event.currentTarget); // Set anchor to the clicked element
  };

  const handleCoursesClick = (event) => {
    setAnchorElCourses(event.currentTarget);
  };

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  const navigateTo = (country, type) => {
    console.log(type)
    const routes = {
      studyVisa: {
        "USA": "/Susa",
        "UK": "/Suk",
        "Australia": "/Saustralia",
        "Canada": "/Scanada"
      },
      residentVisa: {
        "USA": "/Rusa",
        "UK": "/Ruk",
        "Australia": "/Raustralia",
        "Canada": "/Rcanada"
      }
    };

    navigate(routes[type][country]);
    handleCloseMenu(); // Close the menu after navigation
  };



  const drawerContent = (
    <List>
      <ListItem button component="a" href="/">
        <ListItemText primary="Home" />
      </ListItem>
      <ListItem button onClick={handleCoursesClick}>
        <ListItemText primary="Services" />
      </ListItem>
      <Menu
        anchorEl={anchorElCourses}
        open={Boolean(anchorElCourses)}
        onClose={handleCloseMenu}
      >
        <MenuItem onClick={handleCloseMenu} component="a" href="/Webcourse">
          <ListItemIcon><School /></ListItemIcon>
          Courses
        </MenuItem>

        <MenuItem onClick={handleCloseMenu} component="a" href="/Webmigration">
          <ListItemIcon><FlightTakeoff /></ListItemIcon>
          Migration
        </MenuItem>
        <Divider />


        <MenuItem
          onMouseEnter={(e) => {
            setResidentVisaAnchorEl(null); // Close Resident Visa menu
            setStudyVisaAnchorEl(e.currentTarget); // Open Study Visa menu
          }}
        >
          <ListItemIcon><Public /></ListItemIcon> Study Visa <ChevronRight />
        </MenuItem>
        <Popper
          open={Boolean(studyVisaAnchorEl)}
          anchorEl={studyVisaAnchorEl}
          placement="right-start"
          style={{ zIndex: 1300 }}
        >
          <Paper elevation={3} style={{ width: 180 }}>
            {countries.map((country) => (
              <MenuItem
                key={country}
                onClick={() => {
                  console.log(`Clicked on ${country}`); // Debug log
                  navigateTo(country, "studyVisa");
                  handleCloseMenu();
                }}
              >
                <ListItemText>{country}</ListItemText>
              </MenuItem>

            ))}
          </Paper>
        </Popper>


        <MenuItem
          onMouseEnter={(e) => {
            setStudyVisaAnchorEl(null); // Close Study Visa menu
            setResidentVisaAnchorEl(e.currentTarget); // Open Resident Visa menu
          }}
        >
          <ListItemIcon><Public /></ListItemIcon> Resident Visa <ChevronRight />
        </MenuItem>
        <Popper
          open={Boolean(residentVisaAnchorEl)}
          anchorEl={residentVisaAnchorEl}
          placement="right-start"
          style={{ zIndex: 1300 }}
        >
          <Paper elevation={3} style={{ width: 180 }}>
            {countries.map((country) => (
              <MenuItem
                key={country}
                onClick={() => {
                  console.log(`Clicked on ${country}`); // Debug log
                  navigateTo(country, "residentVisa");
                  handleCloseMenu();
                }}
              >
                <ListItemText>{country}</ListItemText>
              </MenuItem>

            ))}
          </Paper>
        </Popper>

      </Menu>

      <ListItem button component="a" href="/about">
        <ListItemText primary="About Us" />
      </ListItem>
      <ListItem button component="a" href="/Contactwebsite">
        <ListItemText primary="Contact" />
      </ListItem>
      <ListItem button component="a" href="/Elearn">
        <Button variant="contained" color="secondary" fullWidth>
          E-Learning <i className="fa fa-arrow-right ms-2"></i>
        </Button>
      </ListItem>
      <ListItem button component="a" href="/login">
        <Button variant="contained" color="secondary" fullWidth>
          Get Started <i className="fa fa-arrow-right ms-2"></i>
        </Button>
      </ListItem>
    </List>
  );

  return (
    <>
      {/* Topbar */}
      <div style={{ backgroundColor: '#343a40', color: '#f8f9fa', padding: '10px 0' }}>
        <Grid container>
          <Grid item xs={12} md={7} container justifyContent="flex-start" alignItems="center">
            <Typography variant="body2" style={{ marginLeft: '20px' }}>
              <i className="fa fa-map-marker-alt text-primary me-2"></i> Selegie Court , #04-153C, Selegie Road Singapore - 188 316
            </Typography>
            <Typography variant="body2" style={{ marginLeft: '20px' }}>
              <i className="far fa-clock text-primary me-2"></i> alliansinternationalcollege@gmail.com
            </Typography>
          </Grid>
          <Grid item xs={12} md={5} container justifyContent="flex-end" alignItems="center">
            <Typography variant="body2" style={{ marginRight: '20px' }}>
              <i className="fa fa-phone-alt text-primary me-2"></i> Tel: +65 8894 4752
            </Typography>
            <IconButton href="#" size="small"><Facebook /></IconButton>
            <IconButton href="#" size="small"><Twitter /></IconButton>
            <IconButton href="#" size="small"><LinkedIn /></IconButton>
            <IconButton href="#" size="small"><Instagram /></IconButton>
          </Grid>
        </Grid>
      </div>

      {/* Navbar */}
      <AppBar position="sticky" style={{ background: 'linear-gradient(90deg, #007bff, #0056b3)' }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" aria-label="logo" href="index.html">
            <img src={logopng} style={{ width: '50px' }} alt="Logo" />
          </IconButton>
          <Typography variant="h6" style={{ flexGrow: 1, marginLeft: '10px' }}>
            Allians International College
          </Typography>
          {isMobile ? (
            <>
              <IconButton edge="end" color="inherit" onClick={handleDrawerToggle}>
                <MenuIcon />
              </IconButton>
              <Drawer anchor="right" open={mobileOpen} onClose={handleDrawerToggle}>
                {drawerContent}
              </Drawer>
            </>
          ) : (
            <>
              <Button
                color="inherit"
                href="/" sx={{ color: 'white', '&:hover': { backgroundColor: '#F9BB16', color: 'black', }, borderRadius: '8px', padding: '10px 20px', transition: 'background-color 0.3s ease', }}
              >
                Home
              </Button>
              <Button color="inherit" sx={{ color: 'white', '&:hover': { backgroundColor: '#F9BB16', color: 'black', }, borderRadius: '8px', padding: '10px 20px', transition: 'background-color 0.3s ease', }}
                onClick={handleCoursesClick}>Services</Button>

              <Menu
                anchorEl={anchorElCourses}
                open={Boolean(anchorElCourses)}
                onClose={handleCloseMenu}
              >
                <MenuItem onClick={handleCloseMenu} component="a" href="/Webcourse">
                  <ListItemIcon><School /></ListItemIcon>
                  Courses
                </MenuItem>
                <MenuItem onClick={handleCloseMenu} component="a" href="/Webmigration">
                  <ListItemIcon><FlightTakeoff /></ListItemIcon>
                  Migration
                </MenuItem>



                <Divider />
                <MenuItem
                  onMouseEnter={(e) => {
                    setResidentVisaAnchorEl(null); // Close Resident Visa menu
                    setStudyVisaAnchorEl(e.currentTarget); // Open Study Visa menu
                  }}
                >
                  <ListItemIcon><Public /></ListItemIcon> Study Visa <ChevronRight />
                </MenuItem>
                <Popper
                  open={Boolean(studyVisaAnchorEl)}
                  anchorEl={studyVisaAnchorEl}
                  placement="right-start"
                  style={{ zIndex: 1300 }}
                >
                  <Paper elevation={3} style={{ width: 180 }}>
                    {countries.map((country) => (
                      <MenuItem
                        key={country}
                        onClick={() => {
                          console.log(`Clicked on ${country}`); // Debug log
                          navigateTo(country, "studyVisa");
                          handleCloseMenu();
                        }}
                      >
                        <ListItemText>{country}</ListItemText>
                      </MenuItem>

                    ))}
                  </Paper>
                </Popper>

                <MenuItem
                  onMouseEnter={(e) => {
                    setStudyVisaAnchorEl(null); // Close Study Visa menu
                    setResidentVisaAnchorEl(e.currentTarget); // Open Resident Visa menu
                  }}
                >
                  <ListItemIcon><Public /></ListItemIcon> Resident Visa <ChevronRight />
                </MenuItem>
                <Popper
                  open={Boolean(residentVisaAnchorEl)}
                  anchorEl={residentVisaAnchorEl}
                  placement="right-start"
                  style={{ zIndex: 1300 }}
                >
                  <Paper elevation={3} style={{ width: 180 }}>
                    {countries.map((country) => (
                      <MenuItem
                        key={country}
                        onClick={() => {
                          console.log(`Clicked on ${country}`); // Debug log
                          navigateTo(country, "residentVisa");
                          handleCloseMenu();
                        }}
                      >
                        <ListItemText>{country}</ListItemText>
                      </MenuItem>

                    ))}
                  </Paper>
                </Popper>


              </Menu>
              <Button color="inherit" sx={{ color: 'white', '&:hover': { backgroundColor: '#F9BB16', color: 'black', }, borderRadius: '8px', padding: '10px 20px', transition: 'background-color 0.3s ease', }} component="a" href="/Elearn">E - Learning </Button>
              <Button color="inherit" sx={{ color: 'white', '&:hover': { backgroundColor: '#F9BB16', color: 'black', }, borderRadius: '8px', padding: '10px 20px', transition: 'background-color 0.3s ease', }} component="a" href="/about">About Us</Button>
              <Button color="inherit" sx={{ color: 'white', '&:hover': { backgroundColor: '#F9BB16', color: 'black', }, borderRadius: '8px', padding: '10px 20px', transition: 'background-color 0.3s ease', }} component="a" href="/Contactwebsite">Contact</Button>
              <Button variant="inherit" sx={{
                backgroundColor: '#F9BB16',
                color: 'black',
                '&:hover': {
                  backgroundColor: 'White',
                  color: 'black',
                },
                marginLeft: '2px',
                borderRadius: '8px',
                padding: '10px 20px',
                transition: 'background-color 0.3s ease',
              }} href="/login">
                Get Started <i className="fa fa-arrow-right ms-2"></i>
              </Button>
            </>
          )}
        </Toolbar>
      </AppBar >
    </>
  );
};

export default Navbar;
